<h3 mat-dialog-title>Create Your Profile</h3>
<mat-dialog-content>
    <app-onboarding-form (formChange)="onFormChange($event)" [isSaving]="isSaving"></app-onboarding-form>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-flat-button mat-dialog-close>Close</button>
    <button mat-flat-button color="primary" [disabled]="isSaving" [appIndeterminateButtonLoading]="isSaving" (click)="onSaveClicked()">Save</button>
</mat-dialog-actions>
